import { Icon } from '../layout/Icon.jsx';

/** بديل قائمة القاصات أثناء الشفت: النقد يدخل درج الشفت حصراً. */
export function ShiftDrawerNote({ shift }) {
  if (!shift) return null;
  return (
    <div
      className="flex items-center gap-2 rounded-[10px] px-3 py-2 text-[12.5px]"
      style={{ background: '#F0FDF4', border: '1px solid #BBF7D0', color: '#166534' }}
    >
      <Icon name="cashbox" size={14} />
      <span>
        النقد يدخل درج شفتك: <b>{shift.cashboxName}</b>
      </span>
    </div>
  );
}
